// extracted by mini-css-extract-plugin
export var label = "_g9-2";
export var slideContainer = "_g9-0";
export var slider = "_g9-1";